/**
 * Event Service
 * Historical events service API: a read-only record of what happened inside a Convercus loyalty program. It serves the stored event history for accounts, memberships and users, for coupons, for news posts and for workflows, filtered by subject, date range, originating user and event type. Every endpoint is a paginated read; the service never writes, edits or replays events.
 *
 * The version of the OpenAPI document: v1.0.37758
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { WorkflowDto } from './workflow-dto';
import { WorkflowNodeDto } from './workflow-node-dto';


export interface WorkflowEventDto { 
    /**
     * Event ID
     */
    _id: string;
    /**
     * Workflow Event type
     */
    eventType: WorkflowEventDto.EventTypeEnum;
    /**
     * Subject information
     */
    subject: WorkflowDto | WorkflowNodeDto;
    /**
     * Program identifier
     */
    program: string;
    /**
     * Creation timestamp
     */
    createdAt: string;
    /**
     * Username who generated the event
     */
    userName: string;
    /**
     * User ID who generated the event
     */
    userId: string;
}
export namespace WorkflowEventDto {
    export type EventTypeEnum = 'WORKFLOWS_CREATED' | 'WORKFLOWS_UPDATED' | 'WORKFLOWS_DELETED' | 'WORKFLOWNODES_CREATED' | 'WORKFLOWNODES_UPDATED' | 'WORKFLOWNODES_DELETED';
    export const EventTypeEnum = {
        WorkflowsCreated: 'WORKFLOWS_CREATED' as EventTypeEnum,
        WorkflowsUpdated: 'WORKFLOWS_UPDATED' as EventTypeEnum,
        WorkflowsDeleted: 'WORKFLOWS_DELETED' as EventTypeEnum,
        WorkflownodesCreated: 'WORKFLOWNODES_CREATED' as EventTypeEnum,
        WorkflownodesUpdated: 'WORKFLOWNODES_UPDATED' as EventTypeEnum,
        WorkflownodesDeleted: 'WORKFLOWNODES_DELETED' as EventTypeEnum
    };
}


